export default "__VITE_ASSET__BJTJCSbb__"